import { useSettings } from '@/context/SettingsContext';
import { formatINR } from '@/lib/api';

export default function Shipping() {
  const { settings } = useSettings();
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
      <h1 className="font-heading text-3xl sm:text-4xl text-stone-900">Shipping & Delivery</h1>
      <ul className="mt-4 space-y-2 text-stone-700">
        <li>• Free delivery on orders above <span className="font-semibold">{formatINR(settings.free_delivery_above || 299)}</span>.</li>
        <li>• Below that, flat delivery charge of <span className="font-semibold">{formatINR(settings.delivery_charge || 30)}</span>.</li>
        <li>• Minimum order value: <span className="font-semibold">{formatINR(settings.min_order_value || 199)}</span>.</li>
        <li>• Expected delivery: <span className="font-semibold">{settings.delivery_time_text || 'Depends on service area, distance and product availability'}</span>.</li>
        <li>• We currently deliver across Faridabad, Ballabgarh and nearby serviceable areas. All prices are in Indian Rupees (₹).</li>
        <li>• Payment: Cash on Delivery only.</li>
      </ul>
    </div>
  );
}
